module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Perfis")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: 'Perfis',
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row collapse in",
    staticStyle: {
      "width": "inherit",
      "height": "auto"
    },
    attrs: {
      "aria-expanded": "true",
      "aria-hidden": "false"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "dark-primary",
      "size": "button--size-ss",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cadastro-perfis-edita'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Novo Perfil ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-offset-4 col-sm-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-empty",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa..."
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.filter,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.filter = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "bordered": _vm.bordered,
      "items": _vm.items,
      "hover": _vm.hover,
      "fields": _vm.fields,
      "filter": _vm.filter,
      "current-page": _vm.currentPage,
      "per-page": 10,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "filtered": _vm.onFiltered,
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "active",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }, {
      key: "createdAt",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "updatedAt",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(!row.item.admin) ? _c('div', [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "disabled": !_vm.verificaAcesso('perfil-editar')
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$router.push({
                name: 'cadastro-perfis-edita',
                params: {
                  id: row.item.id
                }
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  Editar")]), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "warning",
            "size": "button--size-ss",
            "disabled": !_vm.verificaAcesso('perfil-ativar-inativar')
          },
          nativeOn: {
            "click": function($event) {
              return _vm.inativa(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" " + _vm._s(row.item.active ? ' Inativar' : ' Ativar'))])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    staticClass: "my-3",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Consulta de Perfis")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c332600!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/perfis/listaPerfis.vue
// module id = 2030
// module chunks = 1